// extracted by mini-css-extract-plugin
export default {"wrap":"Education_wrap__SXKeq","eduItem":"Education_eduItem__AewJY","degree":"Education_degree__7OCT+","school":"Education_school__PHyZR","eduMeta":"Education_eduMeta__2B3-L"};